export default "<svg viewBox=\"0 0 24 24\">\n  <path d=\"M6 13v-2h12v2z\" />\n</svg>"